// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__5CsxT","options":"AnswerScale_options__3ilQ5","selected":"AnswerScale_selected__2GQzc"};